/**
 * Tamil (தமிழ்) translations
 */
import { TranslationStrings } from '../types';

export const ta: TranslationStrings = {  common: {
    loading: 'ஏற்றுகிறது...',
    error: 'பிழை ஏற்பட்டது',
    retry: 'மீண்டும் முயற்சிக்கவும்',
    cancel: 'ரத்து செய்',
    confirm: 'உறுதிப்படுத்து',
    back: 'பின்செல்',
    next: 'அடுத்து',
    submit: 'சமர்ப்பி',
    done: 'முடிந்தது',
    close: 'மூடு',
    yes: 'ஆம்',
    no: 'இல்லை',
    required: 'தேவை',
    optional: 'விருப்பமானது',
  },
  consent: {
    secureConsent: 'பாதுகாப்பான ஒப்புதல்',
    yourConsentRequired: 'உங்கள் ஒப்புதல் தேவை',
    consentingAs: 'ஒப்புதல் அளிக்கிறவர்',
    requestingOrg: 'கோரும் நிறுவனம்',
    dataBeingCollected: 'சேகரிக்கப்படும் தரவு',
    purposeOfProcessing: 'செயலாக்கத்தின் நோக்கம்',
    whatYouWillDo: 'நீங்கள் செய்ய வேண்டியது',
    reviewDocuments: 'ஆவணங்களை மதிப்பாய்வு செய்யவும்',
    provideConsent: 'ஒப்புதல் அளிக்கவும்',
    documentsToRead: 'படிக்க வேண்டிய ஆவணங்கள்',
    estimatedTime: 'மதிப்பிடப்பட்ட நேரம்',
    minutes: 'நிமிடங்கள்',
    startReview: 'மதிப்பாய்வைத் தொடங்கு',
    yourRights: 'DPDP சட்டம் 2023 இன் கீழ் உங்கள் உரிமைகள்',
    rightToAccess: 'உங்கள் தரவை அணுகும் உரிமை',
    rightToCorrect: 'உங்கள் தரவைத் திருத்தும் உரிமை',
    rightToWithdraw: 'ஒப்புதலை திரும்பப் பெறும் உரிமை',
    rightToGrievance: 'புகார் அளிக்கும் உரிமை',
    stepOf: 'படி {current} / {total}',
    pleaseReadCarefully: 'ஒப்புதல் அளிக்கும் முன் ஒவ்வொரு ஆவணத்தையும் கவனமாகப் படிக்கவும்.',
    documentsReviewed: 'மதிப்பாய்வு செய்யப்பட்ட ஆவணங்கள்',
    remaining: 'மீதமுள்ளவை',
    allDocumentsReviewed: 'அனைத்து ஆவணங்களும் மதிப்பாய்வு செய்யப்பட்டன!',
    clickToRead: 'படிக்க கீழே உள்ள ஒவ்வொரு ஆவணத்தையும் கிளிக் செய்யவும்',
    proceedToConsent: 'ஒப்புதல் அளிக்க தொடரலாம்',
    markAsRead: 'படித்ததாக குறிக்கவும்',
    continueReading: 'படிப்பைத் தொடர்',
    confirmConsent: 'உங்கள் ஒப்புதலை உறுதிப்படுத்தவும்',
    selectMethod: 'சரிபார்ப்பு முறையைத் தேர்ந்தெடுக்கவும்',
    iAgreeToTerms: 'அனைத்து விதிமுறைகள், கொள்கைகள் மற்றும் ஒப்புதல் ஒப்பந்தங்களை ஏற்றுக்கொள்கிறேன்',
    readAllDocuments: 'எனது ஒப்புதல் தன்னார்வமானது என்றும் எப்போது வேண்டுமானாலும் திரும்பப் பெறலாம் என்றும் புரிந்துகொள்கிறேன்',
    submitConsent: 'ஒப்புதல் சமர்ப்பி',
    submitting: 'சமர்ப்பிக்கிறது...',
    digitalSignature: 'டிஜிட்டல் கையொப்பம்',
    smsVerification: 'SMS சரிபார்ப்பு',
    emailVerification: 'மின்னஞ்சல் சரிபார்ப்பு',
    videoRecording: 'வீடியோ பதிவு',
    audioRecording: 'ஆடியோ பதிவு',
    checkboxConfirmation: 'செக்பாக்ஸ் உறுதிப்படுத்தல்',
    drawSignature: 'உங்கள் கையொப்பத்தை வரையவும்',
    verifyViaSms: 'SMS குறியீடு மூலம் சரிபார்க்கவும்',
    verifyViaEmail: 'மின்னஞ்சல் குறியீடு மூலம் சரிபார்க்கவும்',
    recordVideoConsent: 'வீடியோ ஒப்புதல் பதிவு செய்யவும்',
    recordAudioConsent: 'ஆடியோ ஒப்புதல் பதிவு செய்யவும்',
    confirmByChecking: 'செக் செய்து உறுதிப்படுத்தவும்',
    enterOtp: 'OTP உள்ளிடவும்',
    otpSentTo: 'OTP அனுப்பப்பட்டது',
    resendOtp: 'OTP மீண்டும் அனுப்பு',
    verifyOtp: 'OTP சரிபார்',
    otpVerified: 'OTP சரிபார்க்கப்பட்டது',
    invalidOtp: 'தவறான OTP',
    startRecording: 'பதிவைத் தொடங்கு',
    stopRecording: 'பதிவை நிறுத்து',
    retake: 'மீண்டும் எடு',
    recordingComplete: 'பதிவு முடிந்தது',
    consentSubmitted: 'ஒப்புதல் வெற்றிகரமாக சமர்ப்பிக்கப்பட்டது',
    thankYou: 'ஒப்புதல் அளித்ததற்கு நன்றி',
    confirmationSent: 'உங்கள் மின்னஞ்சலுக்கு உறுதிப்படுத்தல் அனுப்பப்பட்டது',
    referenceNumber: 'குறிப்பு எண்',
    errorSubmitting: 'ஒப்புதல் சமர்ப்பிக்க முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
    pleaseReadDocs: 'முதலில் அனைத்து ஆவணங்களையும் படிக்கவும்',
    pleaseProvideEvidence: 'ஒப்புதல் ஆதாரம் வழங்கவும்',
  },
  documents: {
    privacyPolicy: 'தனியுரிமைக் கொள்கை',
    termsOfService: 'சேவை விதிமுறைகள்',
    consentAgreement: 'ஒப்புதல்',
    dataSharingAgreement: 'தரவு பகிர்வு ஒப்பந்தம்',
    cookiePolicy: 'குக்கீ கொள்கை',
    retentionPolicy: 'தரவு தக்கவைப்புக் கொள்கை',
    gdprNotice: 'GDPR அறிவிப்பு',
    hipaaAuthorization: 'HIPAA அங்கீகாரம்',
    ccpaDisclosure: 'CCPA வெளிப்படுத்தல்',
    aadhaarAuthorization: 'ஆதார் அங்கீகாரம்',
    customDocument: 'தனிப்பயன் ஆவணம்',
  },
  dataCategories: {
    personalInfo: 'தனிப்பட்ட தகவல்',
    contactDetails: 'தொடர்பு விவரங்கள்',
    financialInfo: 'நிதித் தகவல்',
    healthData: 'சுகாதார மற்றும் மருத்துவ தரவு',
    biometricData: 'பயோமெட்ரிக் தரவு',
    locationData: 'இருப்பிட தரவு',
    behavioralData: 'நடத்தை தரவு',
    communicationData: 'தொடர்பு தரவு',
    employmentInfo: 'வேலைவாய்ப்பு தகவல்',
    educationInfo: 'கல்வித் தகவல்',
  },
  a11y: {
    mainContent: 'முக்கிய உள்ளடக்கம்',
    navigation: 'வழிசெலுத்தல்',
    closeModal: 'மோடலை மூடு',
    expandSection: 'பகுதியை விரிவாக்கு',
    collapseSection: 'பகுதியை சுருக்கு',
    documentRead: 'ஆவணம் படிக்கப்பட்டதாக குறிக்கப்பட்டது',
    documentUnread: 'ஆவணம் இன்னும் படிக்கப்படவில்லை',
    progressIndicator: 'முன்னேற்றம்: {current} / {total} ஆவணங்கள் படிக்கப்பட்டன',
    signaturePad: 'கையொப்ப வரைபடம்',
    clearSignature: 'கையொப்பத்தை அழி',
    videoPlayer: 'வீடியோ பதிவு பிளேயர்',
    audioPlayer: 'ஆடியோ பதிவு பிளேயர்',
    requiredField: 'இந்த புலம் தேவை',
    errorMessage: 'பிழை',
    successMessage: 'வெற்றி',
    loadingContent: 'உள்ளடக்கம் ஏற்றப்படுகிறது, காத்திருக்கவும்',
    newWindow: 'புதிய சாளரத்தில் திறக்கும்',
  },
  portal: {
    // General
    myConsents: 'எனது ஒப்புதல்கள்',
    viewManageConsents: 'உங்கள் ஒப்புதல் பதிவுகளைப் பார்க்கவும் நிர்வகிக்கவும்',
    logout: 'வெளியேறு',
    welcomeBack: 'மீண்டும் வரவேற்கிறோம்',
    
    // Tenant selector
    organizationNameOrCode: 'நிறுவனத்தின் பெயர் அல்லது குறியீடு',
    orgPlaceholder: 'உதா., globalhealth அல்லது acme-corp',
    orgHint: 'உங்கள் நிறுவனம் வழங்கிய பெயர் அல்லது குறியீட்டை உள்ளிடவும்',
    findMyOrganization: 'எனது நிறுவனத்தைக் கண்டறியவும்',
    orgNotFound: 'நிறுவனம் கிடைக்கவில்லை. பெயரைச் சரிபார்த்து மீண்டும் முயற்சிக்கவும்.',
    enterOrgName: 'உங்கள் நிறுவனத்தின் பெயர் அல்லது குறியீட்டை உள்ளிடவும்',
    or: 'அல்லது',
    haveDirectLink: 'உங்கள் நிறுவனத்திலிருந்து நேரடி இணைப்பு உள்ளதா?',
    useDirectLink: 'அவர்கள் வழங்கிய இணைப்பைப் பயன்படுத்தவும்',
    privacyProtected: 'உங்கள் தனியுரிமை சட்டத்தால் பாதுகாக்கப்படுகிறது',
    
    // Login flow
    phoneOrEmail: 'தொலைபேசி எண் அல்லது மின்னஞ்சல்',
    enterPhoneOrEmailPlaceholder: 'உங்கள் பதிவு செய்யப்பட்ட தொலைபேசி அல்லது மின்னஞ்சலை உள்ளிடவும்',
    otpWillBeSent: 'உங்களுக்கு ஒரு முறை கடவுச்சொல் (OTP) அனுப்புவோம்',
    sendOtp: 'OTP அனுப்பு',
    enterPhoneOrEmail: 'உங்கள் தொலைபேசி எண் அல்லது மின்னஞ்சலை உள்ளிடவும்',
    otpSentTo: 'OTP அனுப்பப்பட்டது',
    expiresIn: 'காலாவதியாகும்',
    enterOtp: 'OTP உள்ளிடவும்',
    enterValidOtp: 'செல்லுபடியாகும் OTP உள்ளிடவும்',
    verifyOtp: 'OTP சரிபார்',
    resendOtp: 'OTP மீண்டும் அனுப்பு',
    otpVerified: 'OTP சரிபார்க்கப்பட்டது',
    oneMoreStep: 'உங்கள் அடையாளத்தை சரிபார்க்க இன்னும் ஒரு படி',
    enterSecurityAnswer: 'உங்கள் பதிலை உள்ளிடவும்',
    enterAnswer: 'பதிலை உள்ளிடவும்',
    dobFormat: 'வடிவம்: DDMMYYYY (உதா., 15051990 மே 15, 1990)',
    login: 'உள்நுழை',
    startOver: 'மீண்டும் தொடங்கு',
    needHelp: 'உதவி வேண்டுமா?',
    privacyNotice: 'உங்கள் தரவு பொருந்தும் தனியுரிமை சட்டங்களின் கீழ் பாதுகாக்கப்படுகிறது',
    checkUrlOrContact: 'URL ஐ சரிபார்க்கவும் அல்லது உங்கள் நிறுவனத்தைத் தொடர்பு கொள்ளவும்.',
    
    // Consent history
    filterAll: 'அனைத்தும்',
    statusActive: 'செயலில்',
    statusWithdrawn: 'திரும்பப்பெறப்பட்டது',
    statusExpired: 'காலாவதியானது',
    noConsents: 'ஒப்புதல் பதிவுகள் எதுவும் இல்லை',
    noConsentsWithFilter: 'இந்த நிலையில் ஒப்புதல்கள் இல்லை',
    consentedOn: 'ஒப்புதல் அளித்த தேதி',
    expiresOn: 'காலாவதியாகும் தேதி',
    withdrawnOn: 'திரும்பப்பெற்ற தேதி',
    withdrawConsent: 'ஒப்புதலைத் திரும்பப்பெறு',
    withdrawalHistory: 'திரும்பப்பெறுதல் வரலாறு',
    help: 'உதவி',
    
    // Withdrawal
    cannotWithdraw: 'இந்த ஒப்புதலைத் திரும்பப்பெற முடியாது',
    pleaseConfirmWithdrawal: 'விளைவுகளை புரிந்துகொண்டதை உறுதிப்படுத்தவும்',
    importantNotice: 'முக்கிய அறிவிப்பு',
    withdrawalNotice1: 'நிறுவனம் குறிப்பிட்ட நோக்கங்களுக்காக உங்கள் தரவை செயலாக்குவதை நிறுத்தும்.',
    withdrawalNotice2: 'சட்ட இணக்கத்திற்காக சில தரவுகள் தக்கவைக்கப்படலாம்.',
    withdrawalNotice3: 'சில சேவைகளைப் பயன்படுத்த மீண்டும் ஒப்புதல் அளிக்க வேண்டியிருக்கலாம்.',
    withdrawalNotice4: 'பொருந்தும் சட்டங்களைப் பொறுத்து செயலாக்க நேரம் 7-30 நாட்கள் ஆகலாம்.',
    withdrawalReason: 'திரும்பப்பெறுவதற்கான காரணம்',
    withdrawalReasonPlaceholder: 'ஏன் திரும்பப்பெற விரும்புகிறீர்கள் என்று சொல்லுங்கள் (விருப்பமானது)',
    withdrawalConfirmation: 'எனது ஒப்புதலைத் திரும்பப்பெறுவது சில சேவைகளைப் பயன்படுத்தும் என் திறனைப் பாதிக்கலாம் என்பதை புரிந்துகொண்டேன், இந்த கோரிக்கையுடன் தொடர விரும்புகிறேன்.',
    submitWithdrawalRequest: 'திரும்பப்பெறுதல் கோரிக்கையைச் சமர்ப்பி',
    withdrawalSubmitted: 'திரும்பப்பெறுதல் கோரிக்கை சமர்ப்பிக்கப்பட்டது',
    withdrawalSubmittedDesc: 'உங்கள் திரும்பப்பெறுதல் கோரிக்கை சமர்ப்பிக்கப்பட்டது. நிறுவனம் செயலாக்கியவுடன் உங்களுக்கு அறிவிக்கப்படும்.',
    processingTime: 'செயலாக்க நேரம்',
    days: 'நாட்கள்',
    backToHistory: 'ஒப்புதல் வரலாற்றுக்குத் திரும்பு',
    
    // Withdrawal history
    statusPending: 'நிலுவையில்',
    statusApproved: 'அங்கீகரிக்கப்பட்டது',
    statusRejected: 'நிராகரிக்கப்பட்டது',
    noWithdrawals: 'திரும்பப்பெறுதல் கோரிக்கைகள் இல்லை',
    viewConsents: 'உங்கள் ஒப்புதல்களைப் பாருங்கள்',
    requestedOn: 'கோரப்பட்ட தேதி',
    processedOn: 'செயலாக்கப்பட்ட தேதி',
    processingMessage: 'உங்கள் கோரிக்கை செயலாக்கப்படுகிறது. முடிந்தவுடன் உங்களுக்கு அறிவிக்கப்படும்.',
    processingTimeInfo: 'செயலாக்க நேர தகவல்',
    
    // Help section
    yourRights: 'உங்கள் தனியுரிமை உரிமைகள்',
    helpTitle: 'உங்கள் தனியுரிமை உரிமைகளைப் புரிந்துகொள்ளுங்கள்',
    helpSubtitle: 'தனியுரிமை சட்டங்களின் கீழ் உங்கள் உரிமைகளையும் ஒப்புதலை எவ்வாறு நிர்வகிப்பது என்பதையும் அறியுங்கள்.',
    quickActions: 'விரைவு செயல்கள்',
    viewMyConsents: 'எனது ஒப்புதல்களைப் பார்',
    viewWithdrawalRequests: 'திரும்பப்பெறுதல் கோரிக்கைகளைப் பார்',
    loginToViewConsents: 'உங்கள் ஒப்புதல்களைப் பார்க்க உள்நுழையவும்',
    applicableLaws: 'பொருந்தும் தனியுரிமை சட்டங்கள்',
    
    // Rights FAQ
    rightAccessQ: 'அணுகல் உரிமை என்றால் என்ன?',
    rightAccessA: 'உங்களைப் பற்றி என்ன தனிப்பட்ட தரவு சேகரிக்கப்படுகிறது, அது எவ்வாறு பயன்படுத்தப்படுகிறது, யாருடன் பகிரப்படுகிறது என்பதை அறிய உங்களுக்கு உரிமை உள்ளது.',
    rightCorrectQ: 'திருத்த உரிமை என்றால் என்ன?',
    rightCorrectA: 'உங்கள் தனிப்பட்ட தரவு தவறானதாக அல்லது முழுமையற்றதாக இருந்தால், அதைத் திருத்த அல்லது புதுப்பிக்க கோரலாம்.',
    rightWithdrawQ: 'ஒப்புதலைத் திரும்பப்பெறும் உரிமை என்றால் என்ன?',
    rightWithdrawA: 'எந்த நேரத்திலும் உங்கள் ஒப்புதலைத் திரும்பப்பெறலாம். திரும்பப்பெற்றவுடன், நீங்கள் ஒப்புதல் அளித்த நோக்கங்களுக்காக நிறுவனம் உங்கள் தரவை செயலாக்குவதை நிறுத்த வேண்டும்.',
    rightEraseQ: 'அழிப்பு உரிமை என்றால் என்ன?',
    rightEraseA: '"மறக்கப்படும் உரிமை" என்றும் அழைக்கப்படும், உங்கள் தனிப்பட்ட தரவை நீக்க கோரலாம். இருப்பினும், சில தகவல்களை தக்கவைக்க சட்ட காரணங்கள் இருக்கலாம்.',
    
    // Withdrawal FAQ
    withdrawalFaq: 'திரும்பப்பெறுதல் செயல்முறை',
    withdrawHowQ: 'எனது ஒப்புதலை எவ்வாறு திரும்பப்பெறுவது?',
    withdrawHowA: 'உங்கள் கணக்கில் உள்நுழைந்து, ஒப்புதல் வரலாற்றுக்குச் சென்று, செயலில் உள்ள ஒப்புதலில் "ஒப்புதலைத் திரும்பப்பெறு" என்பதைக் கிளிக் செய்யவும்.',
    withdrawTimeQ: 'திரும்பப்பெறுதல் எவ்வளவு நேரம் எடுக்கும்?',
    withdrawTimeA: 'செயலாக்க நேரங்கள் பொருந்தும் சட்டங்களைப் பொறுத்து: DPDP சட்டம் (இந்தியா) - 7 நாட்கள், GDPR (EU) - 30 நாட்கள், CCPA (கலிபோர்னியா) - 45 நாட்கள்.',
    withdrawEffectQ: 'ஒப்புதலைத் திரும்பப்பெற்ற பிறகு என்ன நடக்கும்?',
    withdrawEffectA: 'குறிப்பிட்ட நோக்கங்களுக்காக நிறுவனம் உங்கள் தரவைப் பயன்படுத்துவதை நிறுத்தும். சட்ட இணக்கத்திற்காக சில தரவுகள் தக்கவைக்கப்படலாம்.',
    
    // Security FAQ
    securityFaq: 'கணக்கு பாதுகாப்பு',
    loginSecureQ: 'எனது உள்நுழைவு எவ்வாறு பாதுகாக்கப்படுகிறது?',
    loginSecureA: 'நாங்கள் 3-படி சரிபார்ப்பு செயல்முறையைப் பயன்படுத்துகிறோம்: பதிவு செய்யப்பட்ட தொலைபேசி/மின்னஞ்சலுக்கு OTP, அதைத் தொடர்ந்து பாதுகாப்புக் கேள்வி.',
    dataProtectQ: 'எனது தரவு எவ்வாறு பாதுகாக்கப்படுகிறது?',
    dataProtectA: 'அனைத்து தரவும் போக்குவரத்திலும் நிலையிலும் குறியாக்கம் செய்யப்படுகிறது. DPDP சட்டம், GDPR மற்றும் பிற தனியுரிமை விதிமுறைகளைப் பின்பற்றுகிறோம்.',
    
    // Contact FAQ
    contactFaq: 'தொடர்பு & ஆதரவு',
    grievanceQ: 'புகார் எவ்வாறு தாக்கல் செய்வது?',
    grievanceA: 'நிறுவனத்தின் தரவு பாதுகாப்பு அதிகாரி (DPO) அல்லது புகார் அதிகாரியைத் தொடர்பு கொள்ளலாம்.',
    regulatorQ: 'ஒழுங்குமுறை ஆணையம் யார்?',
    regulatorA: 'இந்தியாவில், தரவு பாதுகாப்பு வாரியம் தனியுரிமை புகார்களைக் கையாளுகிறது. EU வில், உங்கள் தேசிய தரவு பாதுகாப்பு ஆணையத்தைத் தொடர்பு கொள்ளலாம்.',
  },
}
;
